<template>
    <section
        id="hero"
        ref="hero"
        class="hero"
    >
        <canvas
            ref="particleCanvas"
            class="hero-canvas"
        ></canvas>

        <canvas
            ref="threeCanvas"
            class="hero-3d-canvas"
        ></canvas>

        <div class="hero-band"></div>

        <div class="hero-system">
            <span class="system-item system-item-1">
                001
            </span>

            <span class="system-item system-item-2">
                WEB
            </span>

            <span class="system-item system-item-3">
                &lt;/&gt;
            </span>

            <span class="system-item system-item-4">
                SYSTEM
            </span>

            <span class="system-item system-item-5">
                0x01
            </span>

            <span class="system-item system-item-6">
                DIGITAL
            </span>
        </div>

        <div class="hero-content">
            <span class="hero-label">
                {{ 'home_hero' | staticContentAlt }}
            </span>

            <div class="hero-title">
                <img
                    :src="'dantrix-logo-white.svg' | assetsImg"
                    :alt="'home_hero' | staticTitle"
                >
                <!-- <dantrix-logo /> -->

            </div>

            <p class="hero-description">
                {{ 'home_hero' | staticContent }}
            </p>
        </div>
    </section>
</template>

<script>
import * as THREE from 'three';

export default {
    name: 'HomeHero',

    // components: {
    //     dantrixLogo
    // },

    data() {
        return {
            mouseX: 0,
            mouseY: 0,

            particleAnimationFrame: null,
            threeAnimationFrame: null,

            particleContext: null,

            particles: [],
            energyPulses: [],

            scene3D: null,
            camera3D: null,
            renderer3D: null,

            coreGroup: null,
            ring: null,
            ring2: null,

            particleGeometry3D: null,
            particleData3D: [],

            targetRotation: {
                x: 0,
                y: 0
            }
        };
    },

    mounted() {
        this.initParticles();
        this.initThree();
        this.bindEvents();
    },

    beforeDestroy() {
        window.removeEventListener(
            'mousemove',
            this.handleMouseMove
        );

        window.removeEventListener(
            'resize',
            this.handleResize
        );

        if (this.particleAnimationFrame) {
            cancelAnimationFrame(
                this.particleAnimationFrame
            );
        }

        if (this.threeAnimationFrame) {
            cancelAnimationFrame(
                this.threeAnimationFrame
            );
        }

        if (this.renderer3D) {
            this.renderer3D.dispose();
        }
    },

    methods: {
        bindEvents() {
            window.addEventListener(
                'mousemove',
                this.handleMouseMove
            );

            window.addEventListener(
                'resize',
                this.handleResize
            );
        },

        handleMouseMove(event) {
            this.mouseX = event.clientX;
            this.mouseY = event.clientY;

            const centerX =
                window.innerWidth / 2;

            const centerY =
                window.innerHeight / 2;

            const movementX =
                (this.mouseX - centerX) /
                centerX;

            const movementY =
                (this.mouseY - centerY) /
                centerY;

            const items =
                this.$el.querySelectorAll(
                    '.system-item'
                );

            items.forEach((item, index) => {
                const intensity =
                    (index + 1) * 2;
                const emSize =
                    parseFloat(getComputedStyle(item).fontSize);

                item.style.setProperty(
                    '--mouse-x',
                    `${movementX * intensity / emSize}em`
                );

                item.style.setProperty(
                    '--mouse-y',
                    `${movementY * intensity / emSize}em`
                );
            });

            this.targetRotation.y =
                (
                    event.clientX /
                    window.innerWidth
                ) * 2 - 1;

            this.targetRotation.y *= 0.35;

            this.targetRotation.x =
                -(
                    (
                        event.clientY /
                        window.innerHeight
                    ) * 2 - 1
                ) * 0.20;
        },

        initParticles() {
            const canvas =
                this.$refs.particleCanvas;

            if (!canvas) return;

            this.particleContext =
                canvas.getContext('2d');

            this.resizeParticleCanvas();

            this.particles = [];

            const particleCount = 55;

            for (
                let i = 0;
                i < particleCount;
                i++
            ) {
                this.particles.push({
                    x:
                        Math.random() *
                        canvas.width,

                    y:
                        Math.random() *
                        canvas.height,

                    size:
                        Math.random() * 1.6 +
                        0.5,

                    speedX:
                        (Math.random() - 0.5) *
                        0.3,

                    speedY:
                        (Math.random() - 0.5) *
                        0.3
                });
            }

            this.energyPulses = [];

            for (let i = 0; i < 7; i++) {
                this.energyPulses.push({
                    particleA: 0,
                    particleB: 1,
                    progress: Math.random(),
                    speed:
                        0.003 +
                        Math.random() *
                        0.004,
                    active: false,
                    cooldown:
                        Math.random() * 300
                });
            }

            this.animateParticles();
        },

        resizeParticleCanvas() {
            const canvas =
                this.$refs.particleCanvas;

            if (!canvas) return;

            const hero =
                this.$refs.hero;

            if (!hero) return;

            canvas.width =
                hero.clientWidth;

            canvas.height =
                hero.clientHeight;
        },

        updateParticles() {
            const canvas =
                this.$refs.particleCanvas;

            if (!canvas) return;

            const mouseInfluenceDistance = 220;
            const mouseRepulsionDistance = 90;

            this.particles.forEach(
                particle => {
                    particle.x +=
                        particle.speedX;

                    particle.y +=
                        particle.speedY;

                    const dx =
                        this.mouseX -
                        particle.x;

                    const dy =
                        this.mouseY -
                        particle.y;

                    const distance =
                        Math.sqrt(
                            dx * dx +
                            dy * dy
                        );

                    if (
                        distance <
                        mouseInfluenceDistance
                    ) {
                        const angle =
                            Math.atan2(
                                dy,
                                dx
                            );

                        if (
                            distance <
                            mouseRepulsionDistance
                        ) {
                            const force =
                                (
                                    mouseRepulsionDistance -
                                    distance
                                ) /
                                mouseRepulsionDistance;

                            particle.x -=
                                Math.cos(angle) *
                                force *
                                2.5;

                            particle.y -=
                                Math.sin(angle) *
                                force *
                                2.5;
                        } else {
                            const force =
                                (
                                    mouseInfluenceDistance -
                                    distance
                                ) /
                                mouseInfluenceDistance;

                            particle.x +=
                                Math.cos(angle) *
                                force *
                                0.8;

                            particle.y +=
                                Math.sin(angle) *
                                force *
                                0.8;
                        }
                    }

                    if (particle.x < 0) {
                        particle.x =
                            canvas.width;
                    }

                    if (
                        particle.x >
                        canvas.width
                    ) {
                        particle.x = 0;
                    }

                    if (particle.y < 0) {
                        particle.y =
                            canvas.height;
                    }

                    if (
                        particle.y >
                        canvas.height
                    ) {
                        particle.y = 0;
                    }
                }
            );
        },

        updateEnergyPulses() {
            const connectionDistance = 150;

            this.energyPulses.forEach(
                pulse => {
                    if (pulse.cooldown > 0) {
                        pulse.cooldown--;
                        return;
                    }

                    if (!pulse.active) {
                        const connections = [];

                        for (
                            let i = 0;
                            i <
                            this.particles.length;
                            i++
                        ) {
                            for (
                                let j = i + 1;
                                j <
                                this.particles.length;
                                j++
                            ) {
                                const a =
                                    this.particles[i];

                                const b =
                                    this.particles[j];

                                const dx =
                                    a.x - b.x;

                                const dy =
                                    a.y - b.y;

                                const distance =
                                    Math.sqrt(
                                        dx * dx +
                                        dy * dy
                                    );

                                if (
                                    distance <
                                    connectionDistance
                                ) {
                                    connections.push({
                                        a: i,
                                        b: j
                                    });
                                }
                            }
                        }

                        if (connections.length) {
                            const connection =
                                connections[
                                    Math.floor(
                                        Math.random() *
                                        connections.length
                                    )
                                ];

                            pulse.particleA =
                                connection.a;

                            pulse.particleB =
                                connection.b;

                            pulse.progress = 0;
                            pulse.active = true;
                        }
                    }

                    if (pulse.active) {
                        pulse.progress +=
                            pulse.speed;

                        if (
                            pulse.progress >= 1
                        ) {
                            pulse.progress = 0;
                            pulse.active = false;

                            pulse.cooldown =
                                100 +
                                Math.random() *
                                250;
                        }
                    }
                }
            );
        },

        drawParticles() {
            const canvas =
                this.$refs.particleCanvas;

            const ctx =
                this.particleContext;

            if (!canvas || !ctx) return;

            ctx.clearRect(
                0,
                0,
                canvas.width,
                canvas.height
            );

            const connectionDistance = 150;

            for (
                let i = 0;
                i < this.particles.length;
                i++
            ) {
                for (
                    let j = i + 1;
                    j < this.particles.length;
                    j++
                ) {
                    const a =
                        this.particles[i];

                    const b =
                        this.particles[j];

                    const dx =
                        a.x - b.x;

                    const dy =
                        a.y - b.y;

                    const distance =
                        Math.sqrt(
                            dx * dx +
                            dy * dy
                        );

                    if (
                        distance <
                        connectionDistance
                    ) {
                        const opacity =
                            1 -
                            distance /
                            connectionDistance;

                        ctx.beginPath();

                        ctx.moveTo(
                            a.x,
                            a.y
                        );

                        ctx.lineTo(
                            b.x,
                            b.y
                        );

                        ctx.strokeStyle =
                            `rgba(233, 81, 29, ${opacity * 0.32})`;

                        ctx.lineWidth = 0.6;

                        ctx.stroke();
                    }
                }
            }

            this.particles.forEach(
                particle => {
                    ctx.beginPath();

                    ctx.arc(
                        particle.x,
                        particle.y,
                        particle.size,
                        0,
                        Math.PI * 2
                    );

                    ctx.fillStyle =
                        'rgba(255, 255, 255, .75)';

                    ctx.fill();
                }
            );
        },

        drawEnergyPulses() {
            const ctx =
                this.particleContext;

            if (!ctx) return;

            this.energyPulses.forEach(
                pulse => {
                    if (!pulse.active) return;

                    const a =
                        this.particles[
                            pulse.particleA
                        ];

                    const b =
                        this.particles[
                            pulse.particleB
                        ];

                    if (!a || !b) return;

                    const x =
                        a.x +
                        (b.x - a.x) *
                        pulse.progress;

                    const y =
                        a.y +
                        (b.y - a.y) *
                        pulse.progress;

                    ctx.beginPath();

                    ctx.arc(
                        x,
                        y,
                        2,
                        0,
                        Math.PI * 2
                    );

                    ctx.fillStyle =
                        '#E9511D';

                    ctx.shadowBlur = 14;

                    ctx.shadowColor =
                        '#E9511D';

                    ctx.fill();

                    ctx.shadowBlur = 0;
                }
            );
        },

        animateParticles() {
            this.updateParticles();
            this.updateEnergyPulses();
            this.drawParticles();
            this.drawEnergyPulses();

            this.particleAnimationFrame =
                requestAnimationFrame(
                    this.animateParticles
                );
        },

        initThree() {
            const hero =
                this.$refs.hero;

            const canvas =
                this.$refs.threeCanvas;

            if (!hero || !canvas) return;

            this.scene3D =
                new THREE.Scene();

            this.camera3D =
                new THREE.PerspectiveCamera(
                    45,
                    hero.clientWidth /
                        hero.clientHeight,
                    0.1,
                    100
                );

            this.camera3D.position.set(
                0,
                0,
                5.5
            );

            this.renderer3D =
                new THREE.WebGLRenderer({
                    canvas,
                    antialias: true,
                    alpha: true
                });

            this.renderer3D.setPixelRatio(
                Math.min(
                    window.devicePixelRatio,
                    2
                )
            );

            this.renderer3D.setSize(
                hero.clientWidth,
                hero.clientHeight
            );

            this.renderer3D.setClearColor(
                0x000000,
                0
            );

            this.coreGroup =
                new THREE.Group();

            this.scene3D.add(
                this.coreGroup
            );

            const coreGeometry =
                new THREE.IcosahedronGeometry(
                    1.45,
                    2
                );

            const coreMaterial =
                new THREE.MeshStandardMaterial({
                    color: 0x101827,
                    metalness: 0.15,
                    roughness: 0.35,
                    transparent: true,
                    opacity: 0.75
                });

            const core =
                new THREE.Mesh(
                    coreGeometry,
                    coreMaterial
                );

            this.coreGroup.add(core);

            const wireGeometry =
                new THREE.IcosahedronGeometry(
                    1.62,
                    2
                );

            const wireMaterial =
                new THREE.MeshBasicMaterial({
                    color: 0xffffff,
                    wireframe: true,
                    transparent: true,
                    opacity: 0.55
                });

            const wireframe =
                new THREE.Mesh(
                    wireGeometry,
                    wireMaterial
                );

            this.coreGroup.add(
                wireframe
            );

            const ringMaterial =
                new THREE.MeshBasicMaterial({
                    color: 0xffffff,
                    transparent: true,
                    opacity: 0.75
                });

            this.ring =
                new THREE.Mesh(
                    new THREE.TorusGeometry(
                        2.15,
                        0.022,
                        16,
                        128
                    ),
                    ringMaterial
                );

            this.ring.rotation.x =
                Math.PI / 2.45;

            this.coreGroup.add(
                this.ring
            );

            this.ring2 =
                new THREE.Mesh(
                    new THREE.TorusGeometry(
                        1.85,
                        0.016,
                        16,
                        128
                    ),
                    ringMaterial
                );

            this.ring2.rotation.y =
                Math.PI / 2.7;

            this.coreGroup.add(
                this.ring2
            );

            this.createThreeParticles();

            const ambientLight =
                new THREE.AmbientLight(
                    0xffffff,
                    1.4
                );

            this.scene3D.add(
                ambientLight
            );

            const keyLight =
                new THREE.DirectionalLight(
                    0xffffff,
                    3.2
                );

            keyLight.position.set(
                3,
                4,
                5
            );

            this.scene3D.add(
                keyLight
            );

            const orangeLight =
                new THREE.PointLight(
                    0xE9511D,
                    2.5,
                    8
                );

            orangeLight.position.set(
                -2,
                1,
                3
            );

            this.scene3D.add(
                orangeLight
            );

            this.animateThree();
        },

        createThreeParticles() {
            const count = 220;

            const positions =
                new Float32Array(
                    count * 3
                );

            this.particleData3D = [];

            for (
                let i = 0;
                i < count;
                i++
            ) {
                const radius =
                    2.2 +
                    Math.random() * 2;

                const theta =
                    Math.random() *
                    Math.PI *
                    2;

                const phi =
                    Math.acos(
                        Math.random() * 2 -
                        1
                    );

                positions[i * 3] =
                    radius *
                    Math.sin(phi) *
                    Math.cos(theta);

                positions[i * 3 + 1] =
                    radius *
                    Math.sin(phi) *
                    Math.sin(theta);

                positions[i * 3 + 2] =
                    radius *
                    Math.cos(phi);

                this.particleData3D.push({
                    radius,
                    theta,
                    phi,
                    speed:
                        0.0003 +
                        Math.random() *
                        0.0008
                });
            }

            this.particleGeometry3D =
                new THREE.BufferGeometry();

            this.particleGeometry3D.setAttribute(
                'position',
                new THREE.BufferAttribute(
                    positions,
                    3
                )
            );

            const material =
                new THREE.PointsMaterial({
                    color: 0xffffff,
                    size: 0.04,
                    transparent: true,
                    opacity: 0.8,
                    depthWrite: false,
                    blending:
                        THREE.AdditiveBlending
                });

            const particles =
                new THREE.Points(
                    this.particleGeometry3D,
                    material
                );

            this.coreGroup.add(
                particles
            );
        },

        animateThree() {
            if (
                !this.renderer3D ||
                !this.coreGroup ||
                !this.particleGeometry3D
            ) {
                return;
            }

            this.coreGroup.rotation.y +=
                0.0018;

            if (this.ring) {
                this.ring.rotation.z +=
                    0.0035;
            }

            if (this.ring2) {
                this.ring2.rotation.z -=
                    0.0028;
            }

            this.coreGroup.rotation.x +=
                (
                    this.targetRotation.x -
                    this.coreGroup.rotation.x
                ) * 0.025;

            this.coreGroup.rotation.y +=
                (
                    this.targetRotation.y -
                    this.coreGroup.rotation.y
                ) * 0.025;

            const positions =
                this.particleGeometry3D
                    .attributes
                    .position
                    .array;

            this.particleData3D.forEach(
                (data, index) => {
                    data.theta +=
                        data.speed;

                    positions[index * 3] =
                        data.radius *
                        Math.sin(data.phi) *
                        Math.cos(data.theta);

                    positions[index * 3 + 1] =
                        data.radius *
                        Math.sin(data.phi) *
                        Math.sin(data.theta);

                    positions[index * 3 + 2] =
                        data.radius *
                        Math.cos(data.phi);
                }
            );

            this.particleGeometry3D
                .attributes
                .position
                .needsUpdate = true;

            this.renderer3D.render(
                this.scene3D,
                this.camera3D
            );

            this.threeAnimationFrame =
                requestAnimationFrame(
                    this.animateThree
                );
        },

        handleResize() {
            this.resizeParticleCanvas();

            const hero =
                this.$refs.hero;

            if (
                !hero ||
                !this.camera3D ||
                !this.renderer3D
            ) {
                return;
            }

            const width =
                hero.clientWidth;

            const height =
                hero.clientHeight;

            this.camera3D.aspect =
                width / height;

            this.camera3D.updateProjectionMatrix();

            this.renderer3D.setSize(
                width,
                height
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.hero {
    position: relative;

    min-height: 100vh;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 6.875em 1.5em 4.375em;

    background: var(--color-1);

    overflow: hidden;
}

.hero-canvas,
.hero-3d-canvas {
    position: absolute;

    inset: 0;

    width: 100%;
    height: 100%;

    opacity: 1;
}

.hero-canvas {
    z-index: 1;
}

.hero-3d-canvas {
    z-index: 2;

    pointer-events: none;
}

.hero-band {
    position: absolute;

    left: 0;
    right: 0;
    top: 49%;

    transform: translateY(-50%);

    height: 17.8125em;

    z-index: 4;

    pointer-events: none;

    background:
        linear-gradient(
            90deg,
            rgba(20, 60, 115, 0) 0%,
            rgba(20, 60, 115, .10) 8%,
            rgba(35, 83, 150, .22) 22%,
            rgba(44, 98, 177, .34) 50%,
            rgba(35, 83, 150, .22) 78%,
            rgba(20, 60, 115, .10) 92%,
            rgba(20, 60, 115, 0) 100%
        );

    border-top:
        0.0625em solid rgba(255, 255, 255, .05);

    border-bottom:
        0.0625em solid rgba(255, 255, 255, .05);

    backdrop-filter: blur(0.375em);
    -webkit-backdrop-filter: blur(0.375em);
}

.hero-system {
    position: absolute;

    inset: 0;

    z-index: 3;

    pointer-events: none;
}

.system-item {
    position: absolute;

    color:
        rgba(255, 255, 255, .22);

    font-family:
        var(--font-tech);

    font-size: 0.6875em;
    -letter-spacing: 0.125em;

    transform:
        translate(
            var(--mouse-x, 0),
            var(--mouse-y, 0)
        );

    transition:
        transform .2s ease-out;
}

.system-item-1 {
    top: 18%;
    left: 8%;
}

.system-item-2 {
    top: 31%;
    right: 10%;
}

.system-item-3 {
    bottom: 20%;
    left: 3%;
}

.system-item-4 {
    top: 14%;
    right: 24%;
}

.system-item-5 {
    bottom: 16%;
    right: 8%;
}

.system-item-6 {
    bottom: 10%;
    left: 35%;
}

.hero-content {
    position: relative;

    z-index: 10;

    width: 100%;
    max-width: 56.25em;

    margin: -4.375em auto 0;

    text-align: center;
}

.hero-label {
    display: inline-block;

    margin-bottom: 1.125em;

    color: var(--text-4);

    font-family:
        var(--font-tech);

    font-size: 0.9375em;
    font-weight: 600;
    -letter-spacing: 0.25em;

    text-transform: uppercase;
}

.hero-title {
    display: flex;
    justify-content: center;

    margin-bottom: 0.625em;

    img {
        width: 90vw;
        max-width: 42.5em;
        max-height: 11.25em;

        object-fit: contain;
    }
}

.hero-description {
    max-width: 38.75em;

    margin: 0 auto;

    color: var(--text-1);

    font-size:
        clamp(0.9375em, 2vw, 1.125em);

    font-weight: 500;
    line-height: 1.6;
}

@media (min-width: 48em) {
    .hero {
        padding:
            7.5em 7%
            4.6875em;
    }

    .hero-band {
        height: 18.75em;
    }
}

@media (min-width: 62em) {
    .hero {
        justify-content: center;

        padding:
            8.125em 8%
            5em;
    }

    .hero-content {
        max-width: 56.25em;

        margin:
            -5.9375em auto 0;

        text-align: center;
    }

    .hero-title {
        justify-content: center;

        margin-bottom: 0.5em;
    }

    .hero-description {
        margin: 0 auto;
    }

    .hero-3d-canvas {
        width: 100%;
        left: 0;
    }

    .hero-band {
        top: 48%;

        height: 19.375em;
    }
}
</style>